import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    margin: '20px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginRight: theme.spacing(1),
  },
}));

const StepActions = ({ handleBack, handleNext, handleCheckout }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {handleBack && (
        <Button
          onClick={handleBack}
          className={classes.button}
          type="button"
        >
          Back
        </Button>
      )}
      {handleNext && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
          className={classes.button}
          type="button"
        >
          Next
        </Button>
      )}
      {handleCheckout && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleCheckout}
          className={classes.button}
          type="button"
        >
          Proceed to cart
        </Button>
      )}
    </div>
  );
};

StepActions.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  handleCheckout: PropTypes.func,
};

export default StepActions;
